import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import UIModal from 'UIComponents/dialog/UIModal';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeaderImage from 'UIComponents/dialog/UIDialogHeaderImage';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';

const SuccessModal = ({
  header,
  body,
  footer,
  width = 600
}) => /*#__PURE__*/_jsxs(UIModal, {
  centered: true,
  use: "success",
  width: width,
  children: [/*#__PURE__*/_jsx(UIDialogHeaderImage, {
    offsetBottom: 23,
    offsetTop: 99,
    children: /*#__PURE__*/_jsx(UIIllustration, {
      name: "success",
      width: 118
    })
  }), /*#__PURE__*/_jsx(UIDialogHeader, {
    className: "p-top-0",
    children: /*#__PURE__*/_jsx(H2, {
      children: header
    })
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: body
  }), /*#__PURE__*/_jsx(UIDialogFooter, {
    children: footer
  })]
});

SuccessModal.propTypes = {
  header: PropTypes.node,
  body: PropTypes.node,
  footer: PropTypes.node,
  width: PropTypes.number
};
export default SuccessModal;